import React, { Component } from "react";
import _ from "lodash";
import cx from "classnames";

// material-ui imports
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { withStyles } from "@material-ui/core/styles";
import {
  WithStyles,
  createStyles,
  FormControl,
  InputLabel,
  InputBase,
  Typography,
  FormHelperText,
  InputAdornment,
} from "@material-ui/core";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { Error } from "@material-ui/icons";

import {
  SectionFocusedContext,
  SectionFocusedContextValue,
} from "./MyPATBaseSection";

// styles
const styles = (theme: Theme) =>
  createStyles({
    inputRoot: {
      '& .customMargin': {
        margin: 8
      },
      "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
        margin: 80,
        opacity: 0,
      },
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      position: "relative",
      backgroundColor: "white",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      padding: `${theme.spacing.unit / 2}px 0`,
      "& input": {
        "-moz-appearance": "textfield",
        height: theme.spacing.unit * 3.5,
        padding: '0 10px',
        '&::-webkit-input-placeholder': { /* Chrome/Opera/Safari */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        '&::-moz-placeholder': { /* Firefox 19+ */
          color: "hsl(0deg 0% 65%)",
        fontWeight: "normal",
        fontSize: 14,
        opacity: 1,
        },
        '&:-ms-input-placeholder': { /* IE 10+ */
          color: "hsl(0deg 0% 65%)",
        fontWeight: "normal",
        fontSize: 14,
        opacity: 1,
        },
        '&:-moz-placeholder': { /* Firefox 18- */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        }
        
      },

      "& textarea": {
        padding: `0 ${theme.spacing.unit * 2}px`,
        "&[readonly]": {
          cursor: "default",
        },
      },
      "&:focus-within": {
        borderColor: theme.palette.grey[400],
      },
      "label + &": {
        marginTop: theme.spacing.unit * 3,
      },
      "& + p": {
        marginTop: theme.spacing.unit / 4 + "px",
        backgroundColor: '#fafafa'
      },
    },
    logINname: {

    },
    input: {
      "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
        margin: 80,
      },
    },
    inputFormLabel: {
      top: theme.spacing.unit / 2 + "px",
      fontSize: 18,
      color: theme.palette.text.primary,
      "& > span": {
        color: theme.palette.error.light,
      },
    },
    formControlError: {
      "& > div": {
        // background: fade(theme.palette.error.light, 0.1),
        border: "1px solid #F21D1D",
        borderRadius: "4px",
      },
      "& > label": {
        color: "#F21D1D",
      },
      "& >  p": {
        color: theme.palette.error.light,
      },
    },
    formControl: {
      marginBottom: theme.spacing.unit,
    },
    errorText: {
      color: '#F21D1D',
      verticalAlign: "middle",
      marginTop: "3px",
      "& svg": {
        verticalAlign: "bottom",
        marginRight: '5px',
      },
    },
    errorBorder: {
      border: "1px solid #F21D1D",
      borderRadius: "4px",
    },
    customDisabled: {
      pointerEvents: 'none',
      opacity: 0.7,
      "& > input": {
        backgroundColor: "#fff",
        color: "#999 !important",
        cursor: 'no-drop',
        opacity: 0.5,
        '::placeholder': {
          color: '#666 !important'
        }
      },
    },
    clickable: {
      cursor: 'pointer'
    },
    mapTestIcon:{
      height: '20px !important',
      position: "absolute",
      left: 8,
      top: 8,
      zIndex: 10,
    },
});

//@ts-ignore
interface MyPATTextFieldProps extends WithStyles<typeof styles> {
  classes: any;
  fullWidthControl: boolean;
  fullWidthInput: boolean;
  required: boolean;
  min: string;
  max: string;
  label: string;
  inputId: any;
  helperText: string;
  error: boolean;
  errorText: string;
  fieldAttributes: object;
  onFocus?: (event: any) => void;
  onBlur?: (event: any) => void;
  customClasses?: { [key: string]: string };
  type?: string;
  value?: string | number;
  onChange?: (event: any) => void;
  name?: string;
  inputProps: object;
  isCutomMargin: boolean;
  endAdornment?: any;
  isIcon?: boolean;
  iconLocation?: string;
  onIncrementDecrement?: Function;
}

interface MyPATTextFieldState {
  value?: string | number;
}
class MyPATTextField extends Component<
  MyPATTextFieldProps,
  MyPATTextFieldState
> {
  state: MyPATTextFieldState = {
    value: this.props.value || "",
  };
  componentDidUpdate(
    prevProps: MyPATTextFieldProps,
    prevState: MyPATTextFieldState
  ) {
    const { value: currentValue, name } = this.props;
    const { value: prevValue } = prevProps;
    if (!Object.is(prevValue,currentValue)) {
      this.setState({ value: currentValue });
    }

    const { value: prevStateValue } = prevState;
    const { value: currentStateValue } = this.state;
    if (
      prevStateValue !== currentStateValue &&
      currentStateValue !== currentValue
    ) {
      this.props.onChange &&
        this.props.onChange({ target: { name, value: currentStateValue } });
    }
  }
  handleOnChange = (event: any) => {
    const { value } = event.target;
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };
  handleIncOrDec = (action: "inc" | "dec") => {
    const { inputProps = {} } = this.props;
    const { min, max, step = 1 }: any = inputProps;
    
    this.setState((prevState) => {
      let { value } = prevState;
      value =
        value && parseFloat(value.toString())
          ? parseFloat(value.toString())
          : 0;
      const newValue = action === "inc" ? value + parseInt(step, 0) : value - step;
      if (min !== undefined && newValue < parseFloat(min)) {
        return prevState;
      }

      if (max !== undefined && newValue > parseFloat(max)) {
        return prevState;
      }
      this.props.onIncrementDecrement && this.props.onIncrementDecrement({ target: { value: newValue } });
      return {
        ...prevState,
        value: newValue,
      };
    });
  };
  handleFocusAndBlur = (
    e: any,
    setSectionFocus: SectionFocusedContextValue["setSectionFocus"],
    isFocused: boolean
  ) => {
    const { onFocus, onBlur } = this.props;
    setSectionFocus(isFocused);
    if (isFocused) {
      onFocus && onFocus(e);
    } else {
      onBlur && onBlur(e);
    }
  };

  render() {
    const {
      classes,
      fullWidthControl = false,
      fullWidthInput = false,
      required = false,
      label,
      inputId,
      helperText,
      error = false,
      fieldAttributes = {},
      errorText,
      endAdornment,
      onFocus,
      onBlur,
      customClasses = {},
      type = "text",
      name,
      onChange,
      isCutomMargin = false,
      isIcon,
      iconLocation,
      ...inputProps
    } = this.props;


    const { value } = this.state;
    return (
      <SectionFocusedContext.Consumer>
        {({ setSectionFocus, focusedBorder }: SectionFocusedContextValue) => (
          <FormControl
            fullWidth={fullWidthControl}
            className={cx(
              classes.formControl,
              error ? classes.formControlError : ""
            )}
          >
            <>
              {_.isEmpty(label) || (
                <InputLabel
                  shrink
                  htmlFor={inputId}
                  className={classes.inputFormLabel}
                  required={required}
                >
                  {label}
                </InputLabel>
              )}
              {
                isIcon && <img className={classes.mapTestIcon} src={iconLocation} alt="Test Icon" />
              }
              <InputBase
                className={cx(classes.logINname, 'textField')}
                type={type}
                id={inputId}
                value={value}
                name={name}
                onChange={this.handleOnChange}
                classes={{
                  root: cx(classes.inputRoot, 'textField'),
                  input: cx(classes.input, 'textField'),
                  disabled: classes.customDisabled,
                  focused: focusedBorder,
                  ...customClasses,
                }}
                fullWidth={fullWidthInput}
                required={required}
                inputProps={{
                  ...fieldAttributes,
                }}
                {...inputProps}
                onFocus={(e) =>
                  this.handleFocusAndBlur(e, setSectionFocus, true)
                }
                onBlur={(e) =>
                  this.handleFocusAndBlur(e, setSectionFocus, false)
                }
                endAdornment={
                  endAdornment ? endAdornment : (
                    type === "number" && (
                    <InputAdornment position="end" classes={{positionEnd: isCutomMargin ? "customMargin" : ''}}>
                      <div>
                        <div
                          onClick={() => this.handleIncOrDec("inc")}
                          className={classes.clickable}
                        >
                          <img src="/assets/svg/myLibrary/arrowTop.svg" />
                        </div>
                        <div
                          onClick={() => this.handleIncOrDec("dec")}
                          className={classes.clickable}
                        >
                          <img src="/assets/svg/myLibrary/arrowBottom.svg" />
                        </div>
                      </div>
                    </InputAdornment>
                  )
                  )
                }
              />
              {_.isEmpty(helperText) || (
                <FormHelperText>{helperText}</FormHelperText>
              )}
              {error && (
                <Typography
                  className={classes.errorText}
                  variant="caption"
                  color="error"
                >
                  <Error /> {errorText}
                </Typography>
              )}
            </>
          </FormControl>
        )}
      </SectionFocusedContext.Consumer>
    );
  }
}

export default withStyles(styles)(MyPATTextField);
